var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRowSel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 16.707,
    viewBox: "0 0 25 16.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9987",
    "data-name": "Group 9987",
    transform: "translate(0 0.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right_2_",
    "data-name": "arrow-right (2)",
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_267",
    "data-name": "Line 267",
    x2: 10,
    transform: "translate(0 2)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8797",
    "data-name": "Path 8797",
    d: "M12,5l2,2L12,9",
    transform: "translate(-4.038 -5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16889",
    "data-name": "Rectangle 16889",
    transform: "translate(0 6)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 10,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 9,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_30",
    "data-name": "Repeat Grid 30",
    transform: "translate(4 9)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1352 -269)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16890",
    "data-name": "Rectangle 16890",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(1352 269)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1345 -269)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16890-2",
    "data-name": "Rectangle 16890",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(1352 269)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1338 -269)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16890-3",
    "data-name": "Rectangle 16890",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(1352 269)",
    fill: "currentColor"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowSel);
export default __webpack_public_path__ + "static/media/row_sel.ea3419fe.svg";
export { ForwardRef as ReactComponent };